export default __webpack_public_path__ + "static/media/CrimsonPro-Black.cf447268.ttf";